import { useState, useEffect } from "react"
import Styles from "./styles.module.css"
import JourneyListItem from "../../components/JourneyListItem/JouneyListItem";
import useFetchArr from "../../hooks/useFetchArr";
import SkeletonLoader from "../../components/SkeletonLoader/SkeletonLoader";
import ChevronLeft from "../../icons/ChevronLeft";
import getRandomImg from "../../utils/getRandomImg";

export default function ProgramModal({open, program, onClose, isHindi}){
    // console.log(program)
    const [completedJourneys, setCompletedJourneys] = useState([])
    const [img, setImg] = useState(null);

    useEffect(()=>{
      if(open){
        setImg(getRandomImg())
      }
    }, [open])
    
    // useEffect(() => {
    //     const saved = JSON.parse(localStorage.getItem(`completed-${program.id}`)) || [];
    //     setCompletedJourneys(saved);
    // }, [program.id]);

    const {data: journeys, error} = useFetchArr(`https://api.evolveinc.in/api/v3/journeys/${program.id}/day`)
    console.log(error)

    useEffect(() => {
      const saved = []
      if(journeys.length > 0){
        journeys.forEach(journey => {
          const journeyId = journey.content.id;
          const completed = localStorage.getItem(`journey-complete-${journeyId}`)
          if(completed === 'true') saved.push(journeyId);
        });

        setCompletedJourneys(saved)
      }
    }, [journeys])

    useEffect(()=>{
      const handleStorageChange = (event) => {
        if(event.key && event.key.startsWith("journey-complete-")){
          const journeyID = parseInt(event.key.replace("journey-complete-", ""));
          if(!journeyID || !journeys.some(j=>j.content.id === journeyID)) return;

          const updated = localStorage.getItem(event.key) === "true";

          setCompletedJourneys(prev => 
            updated && !prev.includes(journeyID)
            ? [...prev, journeyID]
            : !updated && prev.includes(journeyID)
            ? prev.filter(id => id !== journeyID)
            : prev
          )
        }
      }

      window.addEventListener("storage", handleStorageChange);
      return ()=>window.removeEventListener("storage", handleStorageChange)

    }, [journeys])

    const loading = !journeys || journeys.length === 0;
    console.log(getRandomImg())
    return (
      <div>
        {open && (
          <div className={Styles.ModalOverlay}>
            <div className={Styles.Modal}>
              <div className={Styles.CloseBtn}>
                <ChevronLeft onClick={onClose} />
                <span onClick={onClose}>{isHindi ? "वापस जाएँ" : "Back"}</span>
              </div>
              
              <h2 style={{fontFamily:"GothamRounded", fontWeight: "350", textAlign: "left" }}>{program.title}</h2>
              <img src={img} alt="Image" className={Styles.ModalImage}/>
              <div className={Styles.Sessions}>
                {isHindi ? "सेशन्स" : "Sessions"}
              </div>
              
                {loading? <div><SkeletonLoader count={2}/></div> : 
                <div className={Styles.SessionContainer}>{
                  journeys.map((journey) => (
                  <JourneyListItem
                    status = {completedJourneys.includes(journey.content.id)}
                    journey={journey}
                    isHindi={isHindi}
                  />
                ))}
                </div>}
              
              
            </div>
          </div>
        )}
      </div>
);
}